import { useState, useEffect, useRef } from 'react';
import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';
import Loader from "../Shared/Loader/Loader";
import APIConstant from "../../utils/pathConstants";
import api from "../../utils/apiClient";
import CommonConfig from '../../utils/constant';
import { InputTextarea } from 'primereact/inputtextarea';
import { Calendar } from 'primereact/calendar';
import { useNavigate } from 'react-router-dom';
import Toast from '../Shared/Toast/Toast';
import moment from 'moment';
import { apiBase } from '../../utils/config';
import { MultiSelect } from 'primereact/multiselect';
import { Dialog } from 'primereact/dialog';
import DeleteConfirmation from '../Dialogs/DeleteConfirmation';
import UploadFile from '../UploadFile/UploadFile';
import { useCatchResponse } from '../../utils/useCatchResponse';


const SchoolProfile = () => {
    const firstInputRef = useRef(null);

    const { catchResponse } = useCatchResponse();
    const navigate = useNavigate();
    const fileUploadRef = useRef(null);
    const [boardList, setBoardList] = useState([]);
    const [personalDetailId, setPersonalDetailId] = useState('');
    const [schoolDetailid, setSchoolDetailId] = useState('');
    const [profilePath, setProfilePath] = useState(null);
    const [board, setBoard] = useState([]);
    const [medium, setMedium] = useState([]);
    const [userName, setUserName] = useState('');
    const [schoolIndexNo, setSchoolIndexNo] = useState('');
    const [slogan, setSlogan] = useState('');
    const [schoolEstabalishedDate, setSchoolEstabalishedDate] = useState('');
    const [affiliationNo, setAffiliationNo] = useState('');
    const [affiliationFrom, setAffiliationFrom] = useState('');
    const [affiliationTo, setAffiliationTo] = useState('');
    const [panNo, setPanNo] = useState('');
    const [gstNo, setGSTNo] = useState('');
    const [securityUserID, setSecurityUserID] = useState("");
    const [mediumList, setMediumList] = useState([]);
    const [mobileNumber, setMobileNumber] = useState("");
    const [emailAddress, setEmailAddress] = useState("");
    const [emailErr, setEmailErr] = useState(false);
    const [emailErrText, setEmailErrText] = useState('');
    const [pinCode, setPinCode] = useState('');
    const [currentAddress, setCurrentAddress] = useState('');
    const [planName, setPlanName] = useState('');
    const [planRange, setPlanRange] = useState(null);
    const [isDeleteConfirmation, setIsDeleteConfirmation] = useState(false);
    const [previewProfilePath, setPreviewProfilePath] = useState('');
    const [activeTabIndex, setActiveTabIndex] = useState(0);

    useEffect(() => {
        if (firstInputRef.current) {
            firstInputRef.current.focus();
        }
    }, []);


    useEffect(() => {
        const fetchData = async () => {
            try {
                Loader.show();
                const loginData = CommonConfig.loginData();
                setSecurityUserID(loginData?._id);
                await GetLanguageList();
                await GetBoardList(loginData?._id);
                await GetUserDetail(loginData?._id);
                await getPersonDetail(loginData?._id);
                await getSchoolDetail(loginData?._id);
                Loader.hide();
            } catch (error) {
                Loader.hide();
                console.error('Error in useEffect:', error);
            } finally {
                Loader.hide();
            }
        }
        fetchData();
    }, []);

    const GetLanguageList = async () => {
        try {
            await api.get(APIConstant.path.getLanguageList).then(async response => {
                let res = response;
                if (res.success) {
                    setMediumList(res?.data?.map(x => ({
                        ...x,
                        label: x?.LanguageName,
                        value: x?._id
                    })));
                    Loader.hide();
                }
            }).catch(err => {
                Loader.hide();
                console.log(err);
                catchResponse(err);
            });
        } catch (err) {
            console.log(err);
            catchResponse(err);
        }
    }

    const GetBoardList = async (id) => {
        try {
            let data = {
                UserID: id,
            }
            await api.post(APIConstant.path.getBoardList, data).then(async response => {
                let res = response;
                if (res.success) {
                    setBoardList(res?.data?.map(x => ({
                        label: x?.BoardName || 'Unknown',
                        value: x?._id
                    })));
                    Loader.hide();
                }
            }).catch(err => {
                Loader.hide();
                console.log(err);
                catchResponse(err);
            });
        } catch (err) {
            console.log(err);
            catchResponse(err);
        }
    }

    const GetUserDetail = async (userid) => {
        try {
            let data = {
                id: userid,
            }
            await api.post(APIConstant.path.getUserById, data).then(async response => {
                let res = response;
                if (res.success) {
                    setUserName(res?.data?.Name);
                    setMobileNumber(res?.data?.Phone);
                    setEmailAddress(res?.data?.Email);
                    setPlanName(res?.data?.PlanId);
                    setPlanRange([res?.data?.PlanStartDate ? new Date(res?.data?.PlanStartDate) : '', res?.data?.PlanEndDate ? new Date(res?.data?.PlanEndDate) : ''])
                    setProfilePath(res?.data?.ProfilePhotoUrl ? `${apiBase}/UserProfilePic/${res?.data?.ProfilePhotoUrl}` : null)
                    Loader.hide();
                }
            }).catch(err => {
                Loader.hide();
                console.log(err);
                catchResponse(err);
            });
        } catch (err) {
            console.log(err);
            catchResponse(err);
        }
    }

    const getPersonDetail = async (ID) => {
        try {
            let data = {
                id: ID,
            };
            await api
                .post(APIConstant.path.GetPersonalDetailById, data)
                .then(async (response) => {
                    let res = await response;
                    if (res.success) {
                        Loader.hide();
                        setPersonalDetailId(res?.data?._id);
                        setCurrentAddress(res?.data?.CurrentAddress);
                        setPinCode(res?.data?.PinCode);
                    }
                })
                .catch((err) => {
                    Loader.hide();
                    console.log(err);
                });
        } catch (err) {
            console.log(err);
            catchResponse(err);
        }
    };

    const getSchoolDetail = async (ID) => {
        try {
            let data = {
                id: ID,
            };
            await api
                .post(APIConstant.path.GetSchoolDetailById, data)
                .then(async (response) => {
                    let res = await response;
                    if (res.success) {
                        Loader.hide();
                        setSchoolDetailId(res?.data[0]?._id);
                        setSchoolIndexNo(res?.data[0]?.IndexNo);
                        setSlogan(res?.data[0]?.Slogan);
                        setMedium(res?.data[0]?.Medium?.split(',') || []);
                        setBoard(res?.data[0]?.Board?.split(',') || []);
                        setSchoolEstabalishedDate(res?.data[0]?.SchoolEstablished ? new Date(res?.data[0]?.SchoolEstablished) : '');
                        setAffiliationFrom(res?.data[0]?.AffiliationFrom ? new Date(res?.data[0]?.AffiliationFrom) : '');
                        setAffiliationTo(res?.data[0]?.AffiliationTo ? new Date(res?.data[0]?.AffiliationTo) : '');
                        setAffiliationNo(res?.data[0]?.AffiliationNo);
                        setPanNo(res?.data[0]?.PANNo);
                        setGSTNo(res?.data[0].GSTNo);
                    }
                })
                .catch((err) => {
                    Loader.hide();
                    console.log(err);
                });
        } catch (err) {
            console.log(err);
            catchResponse(err);
        }
    };

    const handleSave = async () => {
        await AddEditPersonalDetail();
        await AddEditSchoolDetail();
        await AddEditUserDetail();
        onReferesh();
        handleBack();
    }

    const onReferesh = () => {
        GetUserDetail(securityUserID);
        getPersonDetail(securityUserID);
        getSchoolDetail(securityUserID);
    }

    const AddEditPersonalDetail = async () => {
        try {
            let data = {
                PersonalId: personalDetailId,
                UserId: securityUserID,
                PinCode: pinCode,
                CurrentAddress: currentAddress,
                CreatedBy: securityUserID,
            };
            Loader.show();
            await api.post(APIConstant.path.AddPersonalDetail, data).then(async response => {
                let res = response;
                if (res.success) {
                    Toast.success({ message: 'Details Updated' });
                    Loader.hide();
                } else {
                    Toast.error({ message: res.message });
                    Loader.hide();
                }
            })
                .catch(() => {
                    Loader.hide();
                });
        } catch (err) {
            console.log(err);
            Loader.hide();
            catchResponse(err);
        }
    };

    const AddEditSchoolDetail = async () => {
        try {
            let data = {
                id: schoolDetailid,
                UserId: securityUserID,
                PANNo: panNo,
                SchoolEstablished: schoolEstabalishedDate ? moment(schoolEstabalishedDate).format("YYYY-MM-DD") : '',
                AffiliationFrom: affiliationFrom ? moment(affiliationFrom).format("YYYY-MM-DD") : '',
                AffiliationTo: affiliationTo ? moment(affiliationTo).format("YYYY-MM-DD") : '',
                AffiliationNo: affiliationNo,
                Board: board.length > 1 ? board.join(',') : board[0],
                Medium: medium.length > 1 ? medium.join(',') : medium[0],
                Slogan: slogan,
                GSTNo: gstNo,
                IndexNo: schoolIndexNo,
                CreatedBy: securityUserID
            };
            Loader.show();
            await api.post(APIConstant.path.AddSchoolDetail, data).then(async response => {
                let res = response;
                if (res.success) {
                    Loader.hide();
                } else {
                    Toast.error({ message: res.message });
                    Loader.hide();
                }
            })
                .catch(() => {
                    Loader.hide();
                });
        } catch (err) {
            console.log(err);
            Loader.hide();
            catchResponse(err);
        }
    };

    const handleFileSelect = (e) => {
        const selectedFile = e.files[0];
        if (selectedFile) {
            const img = new Image();
            img.onload = () => {
                if (img.width === img.height) {
                    setProfilePath(selectedFile);
                    const fileURL = URL.createObjectURL(selectedFile);
                    setPreviewProfilePath(fileURL);
                } else {
                    if (fileUploadRef.current) {
                        fileUploadRef.current.clear();
                    }
                    Toast.error({ message: 'The image must have a 1:1 aspect ratio.' });
                }
            };
            img.onerror = () => {
                if (fileUploadRef.current) {
                    fileUploadRef.current.clear();
                }
                Toast.error({ message: 'Error loading the image.' });
            };

            const reader = new FileReader();
            reader.onload = (event) => {
                img.src = event.target.result;
            };
            reader.readAsDataURL(selectedFile);
        }
    };

    const handleChange = (e, type) => {
        const value = e.target.value;
        const alphanumericValue = value.replace(/[^a-zA-Z0-9\s]/g, '');
        const numericValue = value.replace(/[^0-9]/g, '');
        const numericDecimalValue = value.replace(/[^0-9.]/g, '');
        if (type === 'PAN') {
            setPanNo(alphanumericValue.toUpperCase().trim());
        } else if (type === 'GST') {
            setGSTNo(alphanumericValue.toUpperCase());
        } else if (type === 'AffiliationNo') {
            setAffiliationNo(numericValue);
        } else if (type === 'IndexNo') {
            setSchoolIndexNo(numericDecimalValue);
        } else if (type === 'MobileNo') {
            setMobileNumber(numericValue);
        } else if (type === 'PinCode') {
            setPinCode(numericValue);
        }

    };

    const handleEmailChange = (e) => {
        const value = e.target.value;
        const maxLength = 50;
        if (value.length <= maxLength) {
            setEmailAddress(value);
        }
        const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
        if (!emailPattern.test(value)) {
            setEmailErr(true);
            setEmailErrText('Please enter a valid email address.');
        } else {
            setEmailErr(false);
            setEmailErrText('');
        }
    };

    const AddEditUserDetail = async () => {
        try {
            const formData = new FormData();
            formData.append("id", securityUserID);
            formData.append("Name", userName);
            formData.append("Email", emailAddress);
            formData.append("Phone", mobileNumber);
            formData.append("IsNoLogin", true);
            if (profilePath && profilePath.type) {
                formData.append("userProfilePic", profilePath);
            } else if (CommonConfig.isEmpty(profilePath)) {
                formData.append("ProfilePhotoUrl", '');
            }
            Loader.show();
            await api.post(APIConstant.path.AddUpdateUser, formData, {
                headers: {
                    "Content-Type": "multipart/form-data",
                },
            })
                .then(async (response) => {
                    let res = response;
                    if (res.success) {
                        const event = new CustomEvent("userProfileUpdated");
                        window.dispatchEvent(event);

                    } else {
                        Toast.error({ message: res.message });
                    }
                    Loader.hide();
                })
                .catch((err) => {
                    console.error(err);
                    Toast.error({ message: 'Failed to update user details' });
                    Loader.hide();
                });
        } catch (err) {
            console.log(err);
            Toast.error({ message: 'An error occurred' });
            Loader.hide();
            catchResponse(err);
        }
    };

    const renderFooter = () => (
        <div className="dialog-footer p-d-flex p-ai-center p-jc-end">
            <Button
                label="Cancel"
                className="btn-text-action-secondary"
                onClick={handleClose}
            />
            <Button
                label="Delete"
                className="btn-text-action-primary"
                onClick={() => {
                    setProfilePath('')
                    setPreviewProfilePath('');
                    if (fileUploadRef.current) {
                        fileUploadRef.current.clear();
                    }
                    handleClose()
                }}
            />
        </div>
    );

    const handleClose = () => {
        setIsDeleteConfirmation(false)
    };

    const handleBack = () => {
        const loginData = CommonConfig.loginData();
        CommonConfig.getUserMenu(loginData, navigate, 'Login');
    }

    const handleDelete = (e) => {
        setIsDeleteConfirmation(true)
    };

    return (
        <div className='p-p-0 wayment-owner-dashboard et-master-page'>
            <div className="heading-area p-d-flex p-ai-center p-jc-between p-pt-3 p-pb-2 p-mx-3">
                <div className="p-d-flex p-ai-baseline">
                    <i className="pi pi-user-edit"></i>
                    <h2 className='p-m-0'>User Profile</h2>
                </div>
            </div>
            <div className="e-edit-profile-main p-px-3">
                <div className="p-grid">
                    <div className="p-col-12 p-md-4">
                        <div style={{ height: 265, width: 265, margin: 'auto' }}>
                            <UploadFile label='' note='' preview={previewProfilePath} original={profilePath} uploadHandler={handleFileSelect} uploadRef={fileUploadRef} handleDelete={handleDelete} isEditAllow={true} aspectRatio={1 / 1} />
                        </div>
                    </div>
                    <div className="p-col-12 p-md-8">
                        <div className="p-grid">
                            <div className="p-col-12 p-md-6">
                                <div className="custom-inputs">
                                    <p className='p-m-0'>School Name</p>
                                    <InputText className='p-w-100 p-mt-1' value={userName} autoFocus maxLength={40} onChange={(e) => setUserName(e.target.value)} style={{
                                        fontFamily: "Noto Sans, Arial, sans-serif"
                                    }} />
                                </div>
                            </div>
                            <div className="p-col-12 p-md-6">
                                <div className="custom-inputs">
                                    <p className='p-m-0'>School Index No.</p>
                                    <InputText className='p-w-100 p-mt-1' value={schoolIndexNo} maxLength={20} onChange={(e) => handleChange(e, 'IndexNo')} />
                                </div>
                            </div>
                            <div className="p-col-12 p-md-6">
                                <div className="custom-inputs">
                                    <p className='p-m-0'>Slogan</p>
                                    <InputText className='p-w-100 p-mt-1' id='slogan' value={slogan} maxLength={100} onChange={(e) => {
                                        const alphanumericValue = e?.target?.value?.replace(
                                            /[^a-zA-Z0-9\u0A80-\u0AFF\u0900-\u097F\s,.\-]/g,
                                            ''
                                        );
                                        setSlogan(alphanumericValue);
                                    }} style={{
                                        fontFamily: "Noto Sans, Arial, sans-serif"
                                    }} />
                                </div>
                            </div>
                            <div className="p-col-12 p-md-6">
                                <div className="custom-inputs">
                                    <p className='p-m-0'>Mediums</p>
                                    <MultiSelect className='p-w-100 p-mt-1' id="medium" value={medium} options={mediumList}
                                        onChange={(e) => setMedium(e.value)} placeholder="Select Medium" filter display='chip' />
                                </div>
                            </div>
                            <div className="p-col-12 p-md-6">
                                <div className="custom-inputs">
                                    <p className='p-m-0'>School Established</p>
                                    <Calendar className='p-w-100 p-mt-2 e-sction-btn' id="schoolEstabalishedDate" value={schoolEstabalishedDate} onChange={(e) => setSchoolEstabalishedDate(e.value)} showIcon dateFormat='dd/mm/yy' />
                                </div>
                            </div>
                            <div className="p-col-12 p-md-6">
                                <div className="custom-inputs">
                                    <p className='p-m-0'>Board</p>
                                    <MultiSelect className='p-w-100 p-mt-1' id="board" value={board} options={boardList}
                                        onChange={(e) => setBoard(e.value)} placeholder="Select Board" filter display='chip' />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className='p-grid'>
                    <div className="p-col-12 p-md-4">
                        <div className="custom-inputs">
                            <p className='p-m-0'>Affiliation Number</p>
                            <InputText className='p-w-100 p-mt-1' maxLength={10} value={affiliationNo} onChange={(e) => handleChange(e, 'AffiliationNo')} />
                        </div>
                    </div>
                    <div className="p-col-12 p-md-4">
                        <div className="custom-inputs">
                            <p className='p-m-0'>Affiliation From</p>
                            <Calendar className='p-w-100 e-sction-btn p-mt-2' id="affiliationFrom" value={affiliationFrom} onChange={(e) => setAffiliationFrom(e.value)} showIcon dateFormat='dd/mm/yy' />
                        </div>
                    </div>
                    <div className="p-col-12 p-md-4">
                        <div className="custom-inputs">
                            <p className='p-m-0'>Affiliation To</p>
                            <Calendar className='p-w-100 e-sction-btn p-mt-2' id="affiliationTo" value={affiliationTo} onChange={(e) => setAffiliationTo(e.value)} showIcon dateFormat='dd/mm/yy' />
                        </div>
                    </div>
                    <div className="p-col-12 p-md-4">
                        <div className="custom-inputs">
                            <p className='p-m-0'>PAN</p>
                            <InputText className='p-w-100 p-mt-1' maxLength={10} value={panNo} onChange={(e) => handleChange(e, 'PAN')} />
                        </div>
                    </div>
                    <div className="p-col-12 p-md-4">
                        <div className="custom-inputs">
                            <p className='p-m-0'>GST No. (Optional)</p>
                            <InputText className='p-w-100 p-mt-1' maxLength={15} value={gstNo} onChange={(e) => handleChange(e, 'GST')} />
                        </div>
                    </div>
                    <div className="p-col-12 p-md-4">
                        <div className="custom-inputs">
                            <p className='p-m-0'>Email Address</p>
                            <InputText className='p-w-100 p-mt-1' id="emailAddress" value={emailAddress} onChange={(e) => handleEmailChange(e)} disabled />
                            <span className="p-error block" style={{ color: 'red' }}>
                                {emailErr ? emailErrText : null}
                            </span>
                        </div>
                    </div>
                    <div className="p-col-12 p-md-4">
                        <div className="custom-inputs">
                            <p className='p-m-0'>Contact Number</p>
                            <InputText className='p-w-100 p-mt-1' id="contactNo" maxLength={10} value={mobileNumber} onChange={(e) => handleChange(e, 'MobileNo')} disabled />
                        </div>
                    </div>
                    <div className="p-col-12 p-md-4">
                        <div className="custom-inputs">
                            <p className='p-m-0'>Pin Code</p>
                            <InputText className='p-w-100 p-mt-1' id="pinCode" maxLength={6} value={pinCode} onChange={(e) => handleChange(e, 'PinCode')} />
                        </div>
                    </div>
                    <div className="p-col-12 p-md-4">
                        <div className="custom-inputs">
                            <p className='p-m-0'>Plan Name</p>
                            <InputText id="planName" className='p-w-100 p-mt-1' value={planName} disabled />
                        </div>
                    </div>
                    <div className="p-col-12 p-md-4">
                        <div className="custom-inputs">
                            <p className='p-m-0'>Plan Duration</p>
                            <Calendar
                                value={planRange}
                                selectionMode="range"
                                readOnlyInput
                                disabled
                                dateFormat="dd/mm/yy"
                                showIcon
                                className="p-w-100 p-mt-1"
                                showButtonBar
                            />
                        </div>
                    </div>
                    <div className="p-col-12 p-md-8">
                        <div className="custom-inputs">
                            <p className='p-m-0'>Current Address</p>
                            <InputTextarea className='p-w-100 p-mt-1' id="currentAddress" value={currentAddress} type='textArea' rows={3} cols={30} maxLength={200} onChange={(e) => {
                                const alphanumericValue = e?.target?.value?.replace(
                                    /[^a-zA-Z0-9\u0A80-\u0AFF\u0900-\u097F\s,.\-]/g,
                                    ''
                                );
                                setCurrentAddress(alphanumericValue)
                            }} />
                        </div>
                    </div>

                </div>
            </div>
            <div className="edit-profile-footer p-mx-3 p-d-flex p-ai-center p-jc-end">
                <Button
                    label="Cancel"
                    className="p-m-0 btn-text-action-secondary"
                    onClick={handleBack}
                />
                <Button
                    label="Save"
                    className="p-m-0 btn-text-action-primary p-m-1"
                    onClick={handleSave}
                />

            </div>
            <Dialog
                visible={isDeleteConfirmation}
                onHide={handleClose}
                header={
                    <div className="p-d-flex p-jc-between p-ai-center">
                        <span>Delete Confirmation</span>
                    </div>
                }
                footer={renderFooter()}
                draggable={false}
                dismissableMask
                position="center"
                style={{ width: '450px' }}
            >
                <DeleteConfirmation />
            </Dialog>
        </div>

    );
};

export default SchoolProfile;
